export default __webpack_public_path__ + "static/media/logo.da25da89.png";